export default __webpack_public_path__ + "0459e641da6077b2cd7fab13b68d8ed3.png";